import { useState } from "react";
import { useFetch } from "@/hooks/useFetch";
import { PageHeader } from "@/components/PageHeader";
import { DataTable } from "@/components/DataTable";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { FileSpreadsheet } from "lucide-react";
import { rupiah, tanggal } from "@/lib/format";

const REPORTS = [
  { value: "invoices", label: "Daftar Invoice" },
  { value: "proformas", label: "Proforma Belum Dikonversi" },
  { value: "payments", label: "Pembayaran" },
  { value: "receivables", label: "Aging Piutang" },
  { value: "po", label: "Daftar Purchase Order" },
  { value: "rates", label: "Kontrak & Tarif Aktif" },
];

const COLS = {
  invoices: [["number", "No. Invoice"], ["date", "Tanggal", tanggal], ["grand_total", "Total", rupiah], ["status", "Status"]],
  proformas: [["number", "No. Proforma"], ["date", "Tanggal", tanggal], ["grand_total", "Total", rupiah], ["status", "Status"]],
  payments: [["number", "No"], ["date", "Tanggal", tanggal], ["amount", "Nilai", rupiah], ["method", "Metode"]],
  receivables: [["number", "No. Invoice"], ["client", "Klien"], ["outstanding", "Sisa", rupiah], ["aging_bucket", "Aging"]],
  po: [["number", "No. PO"], ["date", "Tanggal", tanggal], ["invoice_rule", "Aturan"], ["status", "Status"]],
  rates: [["contract_id", "Kontrak"], ["material_id", "Material"], ["rate", "Tarif", rupiah], ["valid_from", "Berlaku", tanggal]],
};

export default function Reports() {
  const [name, setName] = useState("invoices");
  const { data, loading } = useFetch(`/reports/${name}`, [name]);
  const cols = (COLS[name] || []).map(([key, label, fmt]) => ({ key, label, render: fmt ? (r) => fmt(r[key]) : undefined, numeric: fmt === rupiah }));

  const exportCsv = () => {
    const rows = data || [];
    const headers = cols.map((c) => c.label);
    const lines = [headers.join(",")].concat(rows.map((r) => cols.map((c) => `"${String(r[c.key] ?? "")}"`).join(",")));
    const blob = new Blob([lines.join("\n")], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a"); a.href = url; a.download = `laporan-${name}.csv`; a.click();
  };

  return (
    <div>
      <PageHeader title="Laporan" subtitle="Laporan lengkap dengan filter & export"
        action={<Button variant="outline" onClick={exportCsv} data-testid="report-export-btn"><FileSpreadsheet className="h-4 w-4 mr-1" /> Export CSV</Button>} />
      <div className="mb-4 max-w-xs">
        <Select value={name} onValueChange={setName}>
          <SelectTrigger data-testid="report-select"><SelectValue /></SelectTrigger>
          <SelectContent>{REPORTS.map((r) => <SelectItem key={r.value} value={r.value}>{r.label}</SelectItem>)}</SelectContent>
        </Select>
      </div>
      {loading ? <div className="h-64 rounded-md bg-muted animate-pulse" /> : <DataTable testId="reports" data={data || []} columns={cols} />}
    </div>
  );
}
